import { combineReducers } from 'redux';

import CommunityReducers from './CommunityReducers';
import DataReducers from './DataReducers';
import GeneReducers from './GeneReducers';
import GenesetReducers from './GenesetReducers';
import NetworkReducers from './NetworkReducers';
import PredictionReducers from './PredictionReducers';
import VariantReducers from './VariantReducers';
import GenomeReducers from './GenomeReducers';
import DeepSEAReducers from './DeepSEAReducers';
import FetchErrorReducers from './FetchErrorReducers';

const appReducer = combineReducers(
  Object.assign(
    CommunityReducers,
    DataReducers,
    GeneReducers,
    GenesetReducers,
    NetworkReducers,
    PredictionReducers,
    VariantReducers,
    GenomeReducers,
    DeepSEAReducers,
    FetchErrorReducers,
  ),
);

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
